import _ from 'lodash';

import { NAMES as MEMBER_ACTIONS } from '../../actions/member';
import { NAMES as ORGANIZATION_ACTIONS } from '../../actions/organizations';

export const invitations = (state = [], action) => {
  switch (action.type) {
    case MEMBER_ACTIONS.ORGANIZATION_INVITATIONS_SUCCESS:
      return _.map(action.payload, ({ invitation, organization }) => {
        return {
          ...invitation,
          name: organization.name,
        };
      });

    case ORGANIZATION_ACTIONS.INVITE_ACCEPT_SUCCESS:
      return _.filter<any>(
        state,
        (invite) => invite.organizationId !== action.payload.organizationId,
      );

    default:
      return state;
  }
};
